<template src="./calendar.html"></template>

<script>
import { get_calendar, get_clienti, get_utenti, get_tasks, save_task } from "@/api/api.calendar.js";
import dialogCalendario from "@/components/dialog/calendar/CalendarItem";
import DialogTask from "@/components/dialog/calendar/TaskItem";
import DialogEsporta from "@/components/dialog/calendar/Esporta";
import DialogRiprogramma from "@/components/dialog/calendar/Riprogramma";
import ToolbarContent from "./ToolbarContent.vue";

import Holidays from "date-holidays";
import storage from "@/services/storage.js";

export default {
  components: {
    dialogCalendario,
    DialogEsporta,
    DialogTask,
    DialogRiprogramma,
    ToolbarContent
  },

  data: () => ({
    today: new Date().toISOString().substr(0, 10),

    events: [],
    eventoSel: {},

    clienti: [],

    search: "",
    filtriUtenti: [],
    filtroUtenteSel: "",

    dialogIns: false,
    dialogEsporta: false,
    dialogRiprogramma: false,

    selezione: "calendar",

    tasks: [],
    dialogTask: false,
    mostraCompletate: false,
    taskSel: {},

  }),

  methods: {
    async refresh() {
      if (this.selezione == 'calendar')
        await this.caricaDati();
      else
        await this.caricaAttivita();
    },

    //#region Caricamento dati
    async caricaUtenti() {
      this.filtroUtenteSel = this.userName;
      if (this.role != "admin") return;

      let res = await get_utenti();
      this.filtriUtenti = res.data;
    },

    async caricaClienti() {
      // Clienti (servono per la dialog di inserimento, li carico una volta sola)
      let res = await get_clienti();
      this.clienti = res.data;
    },

    async caricaDati() {
      let par = this.today + "/";
      par += this.filtroUtenteSel || "";

      try {
        // Calendario
        let res = await get_calendar(par);

        let dati = res.data;
        // Rimuovo l'ora dalla data
        dati.forEach((element) => {
          element.data = element.data.substring(0, 10);
        });

        this.events = dati;
      } catch (error) {
        console.log(error);
        this.$toast.alert(this.$functions.getErrorMsg(error));
      }
    },

    async caricaAttivita() {
      let par = this.today + "/";
      par += this.filtroUtenteSel || "";

      if (this.mostraCompletate)
        par += "/1";
      let res = await get_tasks(par);

      let dati = res.data;
      dati.forEach((element) => {
        element.data = element.data.substring(0, 10);
      });

      this.tasks = dati;
    },

    //#endregion


    //#region Dialog

    esportaExcel() {
      this.dialogEsporta = true;
    },

    chiudiEsporta() {
      this.dialogEsporta = false;
    },

    async apriDialog(event) {
      // Controllo nuovo inserimento
      if (event) {
        // Modifica
        if (event.festa) return;
        this.eventoSel = event;
      } else {
        // Controllo presenza utente
        if (!!this.filtroUtenteSel == false) {
          this.$toast.info("Utente non selezionato");
          return;
        }

        // Nuovo
        this.eventoSel = {
          data: this.today,
          prog: -1,
          utente: this.filtroUtenteSel,
          utenteCreazione: this.filtroUtenteSel,
        };
      }

      if (this.selezione == 'calendar')
        this.dialogIns = true;
      else {
        {
          // Attivo e disattivo per un attimo l'apertura del menu tasto destro perché altrimenti si aprirebbe anche sul click normale
          this.eventoSel.menuOpen = true;
          await this.$functions.delay(10);
          this.eventoSel.menuOpen = false;
          await this.$functions.delay(10);
          this.dialogTask = true;
        }
      }
    },

    chiudiDialog(aggiorna) {
      this.dialogIns = false;
      this.dialogTask = false;
      this.chiudiMenu();

      if (aggiorna) {
        if (this.selezione == 'calendar')
          this.caricaDati();
        else
          this.caricaAttivita();
      }
    },

    //#endregion


    //#region Azioni menu tasto destro


    async apriMenu(task, event) {
      this.chiudiMenu();
      await this.$functions.delay(50);
      this.taskSel = task;
      if (this.taskSel) {
        this.tasks.forEach(t => {
          t.menuOpen = (t.prog === task.prog && t.data == task.data);
        });
        this.taskSel.menuOpen = true;
      }
    },

    chiudiMenu() {
      this.taskSel = {};
      this.tasks.forEach(t => t.menuOpen = false);
    },

    async completa(task, stato) {
      this.tasks.forEach(t => t.menuOpen = false);

      task.completato = stato;

      try {
        await save_task(task, "");

        this.caricaAttivita();
      } catch (e) {
        console.log(e);
        this.$toast.error("Errore durante l'aggiornamento");
        // rollback in caso di errore
        task.completato = !stato;
      }
    },

    riprogramma() {
      this.dialogRiprogramma = true;
    },

    chiudiRiprogramma(aggiorna) {
      this.dialogRiprogramma = false;
      if (aggiorna)
        this.refresh();
    },

    //#endregion


    //#region Eventi tastiera/mouse

    handleKeyPress(event) {
      if (event.key.toLowerCase() !== "t") return;

      let tag = document.activeElement.tagName;
      let editable = document.activeElement.isContentEditable;
      if (tag === "INPUT" || tag === "TEXTAREA" || editable) return;

      if (this.dialogTask || this.dialogEsporta || this.dialogIns) return;

      this.today = new Date().toISOString().substr(0, 10);
    },

    handleDayDblClick(date) {
      this.today = date;
      this.apriDialog();
    },

    //#endregion


    buildMap(sourceArr) {
      const map = {};
      let swapArr = sourceArr;

      if (this.search) {
        let searchLower = this.search.toLowerCase();
        console.log(swapArr);
        swapArr = swapArr.filter(f =>
          f.ragSoc.toLowerCase().includes(searchLower) || f.descrizione.toLowerCase().includes(searchLower)
        );
      }

      const anno = this.today.substring(0, 4);
      const hd = new Holidays("IT");
      const feste = hd
        .getHolidays(anno)
        .filter(f => f.type.toLowerCase() === "public")
        .map(ff => ({
          data: ff.date.toString().substring(0, 10),
          ragSoc: ff.name,
          festa: true
        }));

      feste.forEach(e => { (map[e.data] = map[e.data] || []).push(e); });

      swapArr.forEach(e => { (map[e.data] = map[e.data] || []).push(e); });
      return map;
    },

    verificaUrl() {
      const params = new URLSearchParams(window.location.search);
      let tool = params.get("tool");
      if (tool == "tasks")
        this.selezione = "tasks"
      else this.selezione = "calendar";
    },

    verificaParametri() {
      const params = new URLSearchParams(window.location.search);
      let data = params.get("data");
      let prog = params.get("prog");
      if (this.selezione == "tasks") {
        if ((data != null && data != "") && (prog != null && prog > 0)) {
          data = this.$functions.formatDate(data);
          let task = this.tasksMap[data]?.find(t => t.prog === Number(prog));
          if (task) {
            this.eventoSel.data = data;
            this.eventoSel.prog = Number(prog);
            this.eventoSel.utenteCreazione = this.utente;
            this.dialogTask = true;
          }
        }
      }
    },

  },

  async mounted() {
    window.addEventListener("keydown", this.handleKeyPress);

    // Imposto l'utente
    this.caricaUtenti();
    this.caricaClienti();

    await this.verificaUrl();

    await this.refresh();

    await this.verificaParametri();
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyPress);
  },

  watch: {
    today() {
      if (this.selezione == 'calendar')
        this.caricaDati();
      else
        this.caricaAttivita();
    },

    selezione() {

      const params = new URLSearchParams(window.location.search);
      let data = params.get("data");
      let prog = params.get("prog");
      if (!data || !prog)
        this.$router.push({ query: { tool: this.selezione } });
      if (this.selezione == 'calendar')
        this.caricaDati();
      else
        this.caricaAttivita();
    },
  },

  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      return this.buildMap(this.events);
    },
    tasksMap() {
      return this.buildMap(this.tasks);
    },

    role() {
      return storage.getRole();
    },

    userName() {
      return storage.getUsername();
    },
  },
};
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: var(--primary);
  color: #ffffff;
  border: 1px solid var(--primary);
  width: 100%;
  font-size: 12px;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 1px;
  padding-bottom: 1px;
  cursor: pointer;
  margin-bottom: 1px;
}

#pulsantiAzione {
  position: fixed;
  right: 1.2em;
  bottom: 1em;
}
</style>
